import React from 'react'
import DefaultLoanCalculator from '../../../loanCalculator/components/DefaultLoanCalculator'

export default () => <DefaultLoanCalculator />
